import styled from "styled-components";
import { pxToRem } from "../../styles/utils";
import {
  ModalCloseButtonBase,
  ModalDividerBase,
  ModalOverlayBase,
  ModalSurfaceBase,
} from "components/Modals/ModalPrimitives";

export const ModalOverlay = styled(ModalOverlayBase)`
  padding: ${({ theme }) => pxToRem(theme.spacing.xl)};
`;

export const ModalPanel = styled(ModalSurfaceBase)`
  width: min(${pxToRem(620)}, calc(100vw - ${pxToRem(48)}));
  max-height: calc(100vh - ${pxToRem(48)});
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)} ${({ theme }) => pxToRem(theme.spacing.xl)};

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.ink};
    font-size: ${({ theme }) => pxToRem(theme.fontSize.xl)};
    font-weight: 700;
  }
`;

export const CloseButton = styled(ModalCloseButtonBase)`
  width: ${({ theme }) => pxToRem(theme.spacing.xxl)};
  height: ${({ theme }) => pxToRem(theme.spacing.xxl)};

  svg {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }
`;

export const Divider = styled(ModalDividerBase)``;

export const ModalBody = styled.div`
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => pxToRem(theme.spacing.xl)};
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.sm)};
`;

export const ToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(34)};
  height: ${pxToRem(34)};
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  background: transparent;
  color: ${({ theme }) => theme.colors.inkMuted};
  cursor: pointer;

  svg {
    width: ${pxToRem(18)};
    height: ${pxToRem(18)};
  }

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.brandSubtle};
    color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const NoteTextArea = styled.textarea`
  width: 100%;
  min-height: ${pxToRem(220)};
  max-height: 50vh;
  padding: ${({ theme }) => pxToRem(theme.spacing.md)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  line-height: 1.5;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.inkMuted};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: inset 0 0 0 ${pxToRem(1)} ${({ theme }) => theme.colors.brand};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.surfaceFaint};
    color: ${({ theme }) => theme.colors.inkMuted};
  }
`;

export const ModalFooter = styled.div`
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.xl)} ${({ theme }) => pxToRem(theme.spacing.xl)};
`;
